module.exports = __webpack_public_path__ + "mainassets/img/form1-cutting.67d27645.svg";